import type { ReactNode } from 'react'

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'

import type { SettingsNavGroup, SettingsNavItem } from './settings-nav-item.interface'
import { SettingsSidebar } from './settings-sidebar.molecule'

interface SettingsLayoutMobileSheetProps {
  groupList: SettingsNavGroup[]
  activeItemId: string
  onItemClick: (item: SettingsNavItem) => void
  sidebarTitle?: string
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export const SettingsLayoutMobileSheet = ({
  groupList,
  activeItemId,
  onItemClick,
  sidebarTitle,
  isOpen,
  onOpenChange,
}: SettingsLayoutMobileSheetProps): ReactNode => (
  <Sheet open={isOpen} onOpenChange={onOpenChange}>
    <SheetContent side="left" className="settings-mobile-sheet w-[280px] p-0">
      <SheetHeader className="sr-only">
        <SheetTitle>{sidebarTitle ?? 'Settings'}</SheetTitle>
      </SheetHeader>
      <SettingsSidebar
        title={sidebarTitle}
        groupList={groupList}
        activeItemId={activeItemId}
        onItemClick={onItemClick}
        className="h-full"
      />
    </SheetContent>
  </Sheet>
)
